import { OktaAuth } from '@okta/okta-auth-js';
import AuthRoutes from '../../apps/auth/AuthRoutes';
import { globalConfig } from '../config/config';
import HAppRoutes from '../features/routes/helpers/HAppRoutes';

const useAuthOkta = () => {
	const oktaAuth = new OktaAuth({
		issuer: globalConfig.get().APP_OKTA_ISSUER,
		clientId: globalConfig.get().APP_OKTA_CLIENT_ID_AUTH,
		redirectUri: window.location.origin + AuthRoutes.okta_callback.path,
		storageManager: {
			token: {
				storageType: 'localStorage',
				// storageTypes: ['sessionStorage'],
				// storageKey: 'salt-okta-tokens-investors',
			},
		},
		tokenManager: {
			autoRenew: true,
			autoRemove: false,
			clearPendingRemoveTokens: false,
			syncStorage: false,
		},
		transformAuthState: async (oktaAuth, authState) => {
			return authState;
		},
	});
	oktaAuth.tokenManager.on('expired', () => {
		oktaAuth.tokenManager.clear();
		window.location.href = HAppRoutes.getPath(AuthRoutes.logout.tag);
	});

	return oktaAuth;
};

export default useAuthOkta;
